export default __webpack_public_path__ + "static/mangiobevo-47818099998a25f44c70d2de659e8d93.png";